module.exports = __webpack_public_path__ + "img/settings.7e19eab3.svg";